(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9396],{

/***/ 1173:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy",
      function () {
        return __webpack_require__(28413);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87379);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10844);
/* harmony import */ var _Animations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1448);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  border-radius: 5px;\n  padding: 12px;\n  p {\n    color: #fff;\n    margin: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  width: 100%;\n  height: 80px;\n  position: relative;\n\n  &::after {\n    content: '';\n    display: block;\n    width: ",
        "px;\n    height: ",
        "px;\n    border: solid ",
        "px ",
        ";\n    border-bottom-color: white;\n    border-radius: 50%;\n    position: absolute;\n    top: calc(50% - ",
        "px);\n    left: calc(50% - ",
        "px);\n    animation: ",
        " linear infinite 0.5s;\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}





const errorTypes = {
    Forbidden: "Non hai il permesso per visualizzare questo contenuto",
    "Store not found": "Non ci sono Store in questa azienda"
};
const Loading = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoadingContainer, {
        error: !!props.error,
        children: props.error ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
            children: errorTypes[props.error] || "Si \xe8 verificato un errore"
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Loader, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Loading);
// Utils
const loadingSize = 20;
const loadingBorder = 3;
const LoadingContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3a305f33-0"
})(_templateObject1(), (props)=>props.error && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject(), (props)=>props.theme.colors.error));
const Loader = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3a305f33-1"
})(_templateObject2(), loadingSize, loadingSize, loadingBorder, (props)=>props.theme.colors.main, loadingSize / 2 + loadingBorder, loadingSize / 2 + loadingBorder, _Animations__WEBPACK_IMPORTED_MODULE_4__/* .spin */ .O2);


/***/ }),

/***/ 79378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87379);
/* harmony import */ var _Admin_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90341);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 3;\n  background-color: #fff;\n  padding: 0 15%;\n  height: ",
        ";\n  box-shadow: 0px 0px 12px ",
        ";\n\n  @media ",
        " {\n    padding: 0 5%;\n  }\n\n  > div {\n    height: 60%;\n    padding: 0;\n    margin: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100vw;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding-top: ",
        ";\n\n  p,\n  ol,\n  ul {\n    font-family: ",
        ";\n    font-size: 14px;\n    line-height: 1.8;\n    color: ",
        ";\n    margin: 0 0 16px;\n  }\n\n  li {\n    margin-bottom: 12px;\n  }\n\n  a {\n    color: ",
        ";\n  }\n\n  h3 {\n    line-height: 1.5;\n  }\n\n  .table-wrapper {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n  }\n\n  table {\n    border: 1px solid ",
        ";\n    border-collapse: collapse;\n\n    td {\n      padding: 16px;\n      vertical-align: top;\n      border: 1px solid ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}




const SimplePage = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Header, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Admin_Layout__WEBPACK_IMPORTED_MODULE_3__/* .Logo */ .TR, {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Page, {
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimplePage);
const Header = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].header.withConfig */ .ZP.header.withConfig({
    componentId: "sc-96ae1ea7-0"
})(_templateObject(), (props)=>props.theme.layout.simplePagesHeader, (props)=>props.theme.colors.shadow, (props)=>props.theme.responsive.tablet);
const Page = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96ae1ea7-1"
})(_templateObject1(), (props)=>props.theme.layout.simplePagesHeader, (props)=>props.theme.typography.main, (props)=>props.theme.colors.bodyText, (props)=>props.theme.colors.main, (props)=>props.theme.colors.border, (props)=>props.theme.colors.border);


/***/ }),

/***/ 1834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAxios; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function dataReducer(state, action) {
    switch(action.type){
        case "success":
            return {
                loading: false,
                result: action.result,
                error: null,
                errorMessage: null
            };
        case "error":
            return {
                loading: false,
                result: null,
                error: action.error,
                errorMessage: action.errorMessage
            };
        default:
            return state;
    }
}
function useAxios(fetcher) {
    let deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(dataReducer, {
        loading: true,
        result: null,
        error: null,
        errorMessage: null
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        (async function() {
            try {
                const result = await fetcher();
                dispatch({
                    type: "success",
                    result
                });
            } catch (e) {
                var ref;
                dispatch({
                    type: "error",
                    error: e,
                    errorMessage: (e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : ref.data) || (e === null || e === void 0 ? void 0 : e.message)
                });
            }
        })();
    }, deps);
    return state;
}


/***/ }),

/***/ 28413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ PrivacyPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _contexts_CompanyContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5076);
/* harmony import */ var _components_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10844);
/* harmony import */ var _components_PageTemplates_SimplePage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79378);
/* harmony import */ var _hook_useAxios__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1834);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62400);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35632);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  width: 70%;\n  margin: 24px auto;\n\n  @media ",
        " {\n    width: 90%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  padding: 36px 15%;\n  background-color: ",
        ";\n  @media ",
        " {\n    padding: 24px 5%;\n  }\n\n  h2 {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}










function PrivacyPage() {
    const [company] = (0,_contexts_CompanyContext__WEBPACK_IMPORTED_MODULE_4__/* .useCompany */ .M_)();
    const { result: privacyPolicy , loading  } = (0,_hook_useAxios__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(()=>(0,_utils_api__WEBPACK_IMPORTED_MODULE_8__/* .fetchCompanyPrivacy */ .zD)(company.id), []);
    const privacyTpl = (privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.text) && (privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.text) !== "<p></p>" ? privacyPolicy.text : "<p>Gentile Ospite, ai sensi del REGOLAMENTO (UE) 2016/679 per la protezione dei dati personali e del D.l.g.s.\nn. 196/2003 , la informiamo che il trattamento dei suoi dati personali nell’ambito del servizio denominato\n“Youmain” inclusi quelli relativi alla prenotazione dell’appuntamento per la videoconferenza e al suo\nsvolgimento (ad esempio i flussi audiovisivi e i documenti condivisi), saranno nella titolarit\xe0 di <strong>".concat(company === null || company === void 0 ? void 0 : company.name, "</strong> e non della nostra societ\xe0.</p>");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
                        children: [
                            "Privacy Policy - ",
                            (company === null || company === void 0 ? void 0 : company.name) || "Youmain"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:title",
                        content: "Privacy Policy - ".concat((company === null || company === void 0 ? void 0 : company.name) || "Youmain")
                    }, "title")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Heading, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_5__/* .HeadingM */ .aw, {
                        children: "Privacy Policy"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_5__/* .HeadingXS */ .Kz, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("em", {
                            children: [
                                "Il seguente documento \xe8 stato revisionato e reso disponibile da",
                                " ",
                                company === null || company === void 0 ? void 0 : company.name,
                                ", titolare del trattamento dei suoi dati personali."
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Main, {
                children: [
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                    !loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: privacyTpl
                        }
                    })
                ]
            })
        ]
    });
}
PrivacyPage.layout = _components_PageTemplates_SimplePage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
const Main = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-776f8dc-0"
})(_templateObject(), (props)=>props.theme.responsive.tablet);
const Heading = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-776f8dc-1"
})(_templateObject1(), (props)=>props.theme.colors.background, (props)=>props.theme.responsive.tablet);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(1173); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);